import attachFileIcon from '@/lib/components/Shared/editor/ckeditor/icons/attachfile';
import { ButtonView, Plugin } from 'ckeditor5';

declare module '@ckeditor/ckeditor5-core' {
	// eslint-disable-next-line no-unused-vars
	interface PluginsMap {
		[AttachFile.pluginName]: AttachFile;
	}
}

class AttachFile extends Plugin {
	public static get pluginName() {
		return 'AttachFile' as const;
	}

	init() {
		const editor = this.editor;
		const t = editor.t;

		editor.ui.componentFactory.add('attachFile', (locale) => {
			const view = new ButtonView(locale);

			view.set({
				label: t('Attach File'),
				icon: attachFileIcon,
				tooltip: true,
			});

			view.on('execute', () => this.fire('upload'));

			return view;
		});
	}
}

export default AttachFile;
